import React, { FC } from "react";
import { UseTranslationContext } from "../Context/TranslationContext";

export const LanguageSelectorComponent: FC = () => {

  // TRANSLATION CONTEXT
  const { currentLanguage, changeLanguage, getKeyFromKeyId } = UseTranslationContext();

  const handleLanguageSelectChange = (event: any) => {
    changeLanguage?.(event.target.value);
  };

  return (
    <>
        <div className="section-languages langSelectSize">
          <div id="group-field-language" className="group-field">
            <div className="text-field-icon">
              <select id="langSelect" className="dropdown w-select" value={currentLanguage} onChange={handleLanguageSelectChange}>
                <option value="fr">{getKeyFromKeyId('LANG_FR')}</option>
                <option value="nl">{getKeyFromKeyId('LANG_NL')}</option>
                <option value="en">{getKeyFromKeyId('LANG_EN')}</option>
              </select>
            </div>
          </div>
        </div>
    </>
  );
}